import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { MiniappSdkDemoInput } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-demo-input';
import { MiniappSdkMethodDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-method-demo';

export const MiniappSdkShowNativePaymentAuth = (): JSX.Element => {
  const intl = useIntl();
  const [type, setType] = useState('');
  const [currency, setCurrency] = useState('');
  const [total, setTotal] = useState('');
  const [subtotal, setSubtotal] = useState('');
  const [tax, setTax] = useState('');
  const [gatewayId, setGatewayId] = useState('');
  const args = useMemo(
    () => [
      type,
      {
        currency,
        authorization_total: parseFloat(total),
        subtotal: parseFloat(subtotal),
        tax: parseFloat(tax),
        payment_gateway_id: parseInt(gatewayId, 10),
      },
    ],
    [type, currency, total, subtotal, tax, gatewayId],
  );

  return (
    <MiniappSdkMethodDemo
      actionGroup="payments"
      action="showNativePayment"
      eventName="showNativePaymentResponse"
      args={args}
    >
      <MiniappSdkDemoInput
        value={type}
        onChange={setType}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.type' })}
        dataTestId="type"
      />
      <MiniappSdkDemoInput
        value={currency}
        onChange={setCurrency}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.currency' })}
        dataTestId="currency"
      />
      <MiniappSdkDemoInput
        value={total}
        onChange={setTotal}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.authorizationTotal' })}
        dataTestId="total"
      />
      <MiniappSdkDemoInput
        value={subtotal}
        onChange={setSubtotal}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.subtotal' })}
        dataTestId="subtotal"
      />
      <MiniappSdkDemoInput
        value={tax}
        onChange={setTax}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.tax' })}
        dataTestId="tax"
      />
      <MiniappSdkDemoInput
        value={gatewayId}
        onChange={setGatewayId}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.gatewayId' })}
        dataTestId="gatewayId"
      />
    </MiniappSdkMethodDemo>
  );
};
